// PageDescription: 닥터나우 메인 페이지
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { useNonF2fMedicalCategories } from '@/entities/medical-category';
import { MEDICAL_CATEGORY_CONFIG } from '@/features/medical-category-display/lib/constants';
import { CustomPageProps } from '@/types/app';
import { createMainPageLdJson } from '@/utils/format';
import { LandingPage } from '@/views/landing-page';
import { QueryClient, dehydrate } from '@tanstack/react-query';

const MainSeo = () => {
  const ldJson = createMainPageLdJson();
  return (
    <>
      <NextSeo
        languageAlternates={[
          {
            hrefLang: 'ja',
            href: 'https://doctornow.jp',
          },
          {
            hrefLang: 'ja-JP',
            href: 'https://doctornow.jp',
          },
          {
            hrefLang: 'ko',
            href: 'https://doctornow.co.kr',
          },
          {
            hrefLang: 'ko-KR',
            href: 'https://doctornow.co.kr',
          },
          {
            hrefLang: 'x-default',
            href: 'https://doctornow.co.kr',
          },
        ]}
      />
      <Head>
        <link rel='stylesheet' type='text/css' href='https://file.doctornow.co.kr/landing/aos.css' />
        <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }} />
      </Head>
    </>
  );
};

const MainPage = ({ client }: CustomPageProps) => {
  return (
    <>
      <MainSeo />
      <LandingPage client={client} />
    </>
  );
};

export default MainPage;

export async function getServerSideProps() {
  const queryClient = new QueryClient();

  await useNonF2fMedicalCategories.prefetchQuery(queryClient, MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE);

  const dehydratedState = dehydrate(queryClient);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydratedState)),
    },
  };
}
